import React, { useState } from 'react'
import { List, Pagination, Slider, Box } from '@mui/material'
import { spacing, fontSizes } from '../styling'
import { AccordionMenuItem } from './AccordionMenuItem'
import { UserListItem } from './UserListItem'
import { ShareDetails } from './ShareDetails'
import { IconButton } from '../buttons/IconButton'

export const paginationSx = {
  margin: 0,
  whiteSpace: 'nowrap',
  flexWrap: 'nowrap',
  '& .MuiSlider-sizeSmall': { width: 200 },
  '& .MuiIconButton-root': { marginTop: `${-spacing.lg}px` },
  '& .MuiPaginationItem-sizeSmall': { fontSize: fontSizes.xxs },
  '& .MuiPaginationItem-page.Mui-selected': {
    backgroundColor: 'primary.main',
    color: 'alwaysWhite.main',
    fontWeight: 500,
  },
}

export const centerSx = { display: 'flex', justifyContent: 'center' }

interface Props {
  title: string
  device?: IDevice
  remove?: string
  users?: IUser[]
  members?: boolean
  connected?: boolean
  perPage?: number
}

export const SharedUsersPaginatedList: React.FC<Props> = ({
  title,
  device,
  remove,
  users = [],
  members,
  connected,
  perPage = 12,
}) => {
  const [page, setPage] = useState<number>(1)

  if (!users?.length) return null

  const pageCount = Math.ceil(users.length / perPage)
  const start = (page - 1) * perPage
  const pageUsers = users.slice(start, start + perPage)

  return (
    <AccordionMenuItem
      gutters
      subtitle={title}
      action={
        <Box sx={paginationSx}>
          {users.length > perPage * 3 ? (
            <>
              <IconButton name="chevron-left" type="solid" color="primary" onClick={() => setPage(page - 1)} />
              <Slider
                valueLabelDisplay="auto"
                valueLabelFormat={() => pageUsers[0]?.email?.substring(0, 1) || '-'}
                max={pageCount}
                onChange={(_e, page) => setPage(Number(page))}
                size="small"
              />
              <IconButton name="chevron-right" type="solid" color="primary" onClick={() => setPage(page + 1)} />
            </>
          ) : (
            users.length > perPage && (
              <Pagination
                sx={{ '& .MuiPagination-ul': paginationSx }}
                count={pageCount}
                onChange={(_e, page) => setPage(Math.max(page, 1))}
                size="small"
              />
            )
          )}
        </Box>
      }
      defaultExpanded
    >
      <List>
        {pageUsers.map((user) => (
          <UserListItem key={user.id} user={user} isConnected={connected} member={members} remove={remove}>
            <ShareDetails user={user} device={device} />
          </UserListItem>
        ))}
      </List>
    </AccordionMenuItem>
  )
}
